import { action } from 'app/actions';

export const GET_STUDENTS_ANSWERS_QUESTION_REPORT =
  'reports/general-panel/GET_STUDENTS_ANSWERS_QUESTION_REPORT';

export const GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE =
  'reports/general-panel/GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE';

export const GET_ES_GRADE_COMPARATIVE_GENERAL =
  'reports/general-panel/GET_ES_GRADE_COMPARATIVE_GENERAL';

export const GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE =
  'reports/general-panel/GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE';

export const getStudentsAnswersQuestionReport = (payload) =>
  action(GET_STUDENTS_ANSWERS_QUESTION_REPORT, { payload });

export const getESGradeComparativeByDiscipline = (payload) =>
  action(GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE, { payload });

export const getESGradeComparativeGeneral = (payload) =>
  action(GET_ES_GRADE_COMPARATIVE_GENERAL, { payload });

export const getESQuestionsDetailsByComparative = (payload) =>
  action(GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE, { payload });
